import axios from "axios";

const API = `${process.env.REACT_APP_API_URL}/business-owner`;

const authHeader = () => ({
  "x-business-owner-token": localStorage.getItem("businessOwnerToken") || ""
});

export const sendLoginOtp = async (phone) => {
  const res = await axios.post(`${API}/send-otp`, { phone });
  return res.data;
};

export const verifyLoginOtp = async (phone, otp) => {
  const res = await axios.post(`${API}/verify-otp`, { phone, otp });
  return res.data;
};

export const getMyBusiness = async () => {
  const res = await axios.get(`${API}/me`, { headers: authHeader() });
  return res.data;
};

export const updateMyBusiness = async (data) => {
  const res = await axios.put(`${API}/update`, data, { headers: authHeader() });
  return res.data;
};

export const addImages = async (formData) => {
  const res = await axios.post(`${API}/images`, formData, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" }
  });
  return res.data;
};

export const deleteImage = async (publicId) => {
  const res = await axios.delete(`${API}/image`, {
    headers: authHeader(),
    data: { publicId }
  });
  return res.data;
};
